'use client';

import { DYRecommendationCarousel } from '@castlery/shared-components';
import { DtStack } from '@castlery/modules-tracking-components';
interface RecommendationCarouselProps {
  blok: {
    _uid: string;
    selector_name: string;
  };
}

const RecommendationCarousel = ({ blok }: RecommendationCarouselProps) => {
  const { _uid, selector_name } = blok;

  const handleLinkClick = (header: string) => {
    if (window?.dataLayer) {
      window.dataLayer.push({
        event: 'trackEvent',
        'eventDetails.category': 'Storyblok',
        'eventDetails.action': 'recommendation_carousel_click',
        'eventDetails.label': header || '',
        'eventDetail.method': document?.title || '',
      });
    }
  };

  return (
    <DtStack uid={_uid} componentName="RecommendationCarousel" useImpression>
      <DYRecommendationCarousel selector_name={selector_name.trim()} onClick={handleLinkClick} />
    </DtStack>
  );
};

export { RecommendationCarousel };
